module.exports = "<div class=\"modal-content\">\r\n  <div class=\"modal-body\">\r\n    <div>\r\n      <iframe width=\"100%\" height=\"350\" ng-src=\"{{mdCtrl.trustedUrl(mdCtrl.modalOptions.video.url)}}\"></iframe>\r\n    </div>\r\n\r\n    <div class=\"modal-footer\" style=\"margin: 0;padding: 10px 0 0;border: 0;\">\r\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"mdCtrl.cancel()\">Cerrar</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/modal-video/modal-video.view.html
 ** module id = 645
 ** module chunks = 0
 **/